import { SvgGoogle } from "@digits-shared/components/SVGIcons/solid/Google.svg"
import { type ButtonVariant, DigitsButton } from "@digits-shared/DesignSystem/Button"

/**
 * Default button render for GoogleLogin
 */
export const ContinueWithGoogle = ({
  onClick,
  disabled,
  loading,
  variant,
}: {
  onClick: () => void
  disabled?: boolean
  loading?: boolean
  variant?: ButtonVariant
}) => (
  <DigitsButton
    type="button"
    id="google-login-button"
    aria-label="Continue with Google"
    label="Continue with Google"
    leftDecorator={<SvgGoogle />}
    $variant={variant || "secondary-dark"}
    loading={loading}
    disabled={disabled}
    onClick={onClick}
    $fullWidth
    $solidIcon
  />
)
